import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Lock } from "lucide-react";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const result = await login(email, password);
      // Route based on role
      if (result.role === "customer") {
        navigate("/customer");
      } else if (result.role === "admin") {
        navigate("/admin");
      } else {
        navigate("/members");
      }
    } catch (err) {
      setError(err.response?.data?.detail || "Invalid email or password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="login-page" className="min-h-[60vh] flex items-center justify-center py-20">
      <div className="w-full max-w-md px-6">
        <div className="bg-white rounded-xl border border-[#E5E2DC] shadow-md p-8">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-full bg-[#1C2E4A]/5 flex items-center justify-center">
              <Lock className="w-5 h-5 text-[#1C2E4A]" />
            </div>
            <h1 className="font-serif text-2xl font-semibold text-[#1C2E4A]">
              Sign In
            </h1>
          </div>

          {error && (
            <div data-testid="login-error" className="bg-red-50 text-red-600 text-sm p-3 rounded-md mb-4 border border-red-200">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} data-testid="login-form" className="space-y-4">
            <div>
              <Label htmlFor="login-email" className="text-[#1A1A1A] text-sm font-medium mb-1.5 block">
                Email
              </Label>
              <Input
                id="login-email"
                type="email"
                data-testid="login-email-input"
                placeholder="admin@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="border-[#E5E2DC] bg-[#FAF9F6] focus:border-[#1C2E4A] focus:ring-1 focus:ring-[#1C2E4A]"
                required
              />
            </div>
            <div>
              <Label htmlFor="login-password" className="text-[#1A1A1A] text-sm font-medium mb-1.5 block">
                Password
              </Label>
              <Input
                id="login-password"
                type="password"
                data-testid="login-password-input"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="border-[#E5E2DC] bg-[#FAF9F6] focus:border-[#1C2E4A] focus:ring-1 focus:ring-[#1C2E4A]"
                required
              />
            </div>
            <button
              type="submit"
              data-testid="login-submit-btn"
              disabled={loading}
              className="w-full bg-[#1C2E4A] text-white hover:bg-[#152238] px-8 py-3 rounded-md transition-colors font-medium disabled:opacity-50"
            >
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
